import "./OrderListGroupStyles.scss"

import React, {useEffect} from 'react';
import {NavLink, useLocation, useParams} from "react-router-dom";
import {useGetOrderGroupDetails} from "../hooks/useGetOrderGroupDetails/useGetOrderGroupDetails";
import ButtonBack from "../../../components/Buttons/buttonBack/ButtonBack";
import DataUndefaind from "../../DataUndifaend/DataUndefaind";

const OrderListGroup = () => {

    const location = useLocation();
    const {id} = useParams();
    const group_name = location.state?.group_name;

    const {
        orderGroupDetails,
        loading,
        error,
        fetchOrderGroupDetails,
    } = useGetOrderGroupDetails();

    useEffect(() => {
        if (id) {
            fetchOrderGroupDetails(id);
        }
    }, [id, fetchOrderGroupDetails]);

    const formatDateTime = (isoString) => {
        if (!isoString) return '';
        const date = new Date(isoString);
        if (isNaN(date.getTime())) return '';

        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');

        return `${hours}:${minutes} ${day}.${month}.${year}`;
    };

    return (
        <div className={"order_list_group-page max--width--control"}>

            <ButtonBack/>

            <div className="order-list-group">

                {orderGroupDetails.length === 0 ?
                    <DataUndefaind text="Здесь пока нет заказов"/>
                    :
                    <div className={'title'}>{group_name} заказы:</div>
                }

                {orderGroupDetails.map((detail) => (
                    <NavLink
                        className={"item"}
                        key={detail.guid}
                        to={`/OrdersDetails/${detail.guid}`}
                        state={{
                            data: detail.guid,
                            statuses_id: id,
                        }}
                    >
                        <div className={"item_header"}>
                            Заказ
                        </div>
                        <div className={"item_body"}>
                            <div>
                                № {detail.guid.split('-')[2]}
                            </div>
                            <div>
                                от {formatDateTime(detail.datetime_create)}
                            </div>
                        </div>
                    </NavLink>
                ))}
            </div>

        </div>
    );
};

export default OrderListGroup;